import {
	StoreActionLoggableName,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { createSafeAction, type SafeAction } from './createSafeAction';
import type { ChatStoreAction } from './types';

type AddStoreChatItemArgs = {
	message: StoreChatItem;
	conversationId?: string;
};

export const addStoreChatItem: SafeAction<[AddStoreChatItemArgs]> = createSafeAction(
	StoreActionLoggableName.addStoreChatItem,
	({ message, conversationId: conversationIdParam }: AddStoreChatItemArgs): ChatStoreAction =>
		({ getState }, { setMessages, getMessages }) => {
			const conversationId = conversationIdParam ?? getState().currentConversationId;
			const currentConversation = getState().conversations[conversationId];
			if (!currentConversation) {
				return;
			}

			setMessages(conversationId, [...getMessages(conversationId), message]);
		},
);
